import { useCallback, useEffect } from 'react';
import { useLayoutEffect } from '~app/hooks';
import { intersects } from './utils';
import { useSurveyFormatContext } from './useSurveyFormatContext';

export default function ActiveViewScrollManager(): null {
  const { views, setActive, active } = useSurveyFormatContext();

  const findActiveAnchor = useCallback(() => {
    const winMidpoint = window.innerHeight / 2 + window.scrollY + 5;
    const currentAnchor = views.find(anchor => {
      const el = anchor?.ref.current;
      if (!el) return false;
      return intersects(winMidpoint, el.offsetTop, el.offsetTop + el.offsetHeight);
    });

    if (currentAnchor && currentAnchor.ref !== active?.ref) {
      setActive(currentAnchor.name, true);
    }
  }, [active, views, setActive]);

  useLayoutEffect(() => {
    window.addEventListener('scroll', findActiveAnchor);
    return () => window.removeEventListener('scroll', findActiveAnchor);
  }, [findActiveAnchor]);

  useEffect(() => {
    findActiveAnchor();
  }, [views, findActiveAnchor]);

  return null;
}
